import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import styles from './vertical-spacer.module.scss';
import SpacerModel from '../../../models/vertical-spacer';

type Props = {
  data: SpacerModel;
};

interface CProps {
  sm?: string;
  md?: string;
  lg?: string;
}

// Do not delete the first height, it is an exception for old safari browsers
const CustomStyles = styled.div`
  .${styles.spacer} {
    height: ${(p: CProps) => p.md};
    height: clamp(
      ${(p: CProps) => p.sm},
      ${(p: CProps) => p.md},
      ${(p: CProps) => p.lg}
    );
  }
`;

const VerticalSpacer = ({ data }: Props) => {
  if (data && data.md) {
    return (
      <CustomStyles sm={data.sm} md={data.md} lg={data.lg}>
        <div className={styles.spacer} />
      </CustomStyles>
    );
  }

  return (
    <div
      className={cx(
        styles.spacer,
        styles[`spacer--${data ? data.size : 'medium'}`]
      )}
    />
  );
};

export default VerticalSpacer;
